import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../Icon"

import styles from "../styles.module.less"

const { Text } = Typography

// Stands in for the deflected chart while Receipt is locked. It never asks for the series, so a
// merchant without the feature costs the endpoint nothing.
const DeflectLockedCard = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.card} data-testid="home-chart-deflected-locked">
      <Flex align="center" gap={8} className={styles.cardHeader}>
        <Icon type="card" className={styles.cardHeaderIcon} />
        <Text strong className={styles.cardTitle}>
          {t("Chargebacks deflected")}
        </Text>
      </Flex>
      <Flex vertical align="center" justify="center" gap={12} className={styles.lockedArea}>
        <span className={styles.lockedIconCircle}>
          <Icon type="lock" className={styles.lockedIcon} />
        </span>
        <span className={styles.lockedBadge}>{t("SOON")}</span>
        <Text type="secondary" className={styles.lockedText}>
          {t("Deflect isn’t available on your account yet — we’ll let you know once it goes live.")}
        </Text>
      </Flex>
    </div>
  )
}

export default DeflectLockedCard
